import { ExclamationTriangleIcon, ExternalLinkIcon } from "@radix-ui/react-icons"
import { Box, Button, Container, Flex, Heading, Select, Text, TextField } from "@radix-ui/themes"
import React, { useEffect, useMemo, useState } from "react"
import useFetch from '../../core/hooks/useFetch'
import TransactionService from '../../core/services/TransactionService'
export default function Balance() {
    const [curerncy, setCurrency] = useState('RUB')
    const [amount, setAmount] = useState('0')
    const [paymentUrl, setPaymentUrl] = useState('')
    const [createTransaction, isLoading, error, errors] = useFetch(async () => {
        const data = await TransactionService.Create(amount, curerncy)
        console.log(data)
        window.open(data.payment_url, "_blank");
    })
    return (
        // <Container>
        //     <Container className="heading-upping-balance p-5">
        //         <Heading>Пополнение баланса</Heading>
        //     </Container>
        //     <hr />
        //     <Container className="form-upping-balance p-5">
        //         <Box className="mb-5">
        //         <Text>Сумма</Text>
        //         <TextField.Root placeholder="Введите сумму платежа" value={amount} type='number' onChange={e => setAmount(e.target.value)}></TextField.Root>
        //         </Box>
        //         <Box className="mb-5">
        //             <Container> 
        //             <Text>
        //                 Валюта
        //             </Text>
        //             </Container>
        //                     <Select.Root defaultValue="RUB" value={curerncy} onValueChange={e => setCurrency(e)}>
        //                     <Select.Trigger variant='surface' />
        //                     <Select.Content>
        //                         <Select.Item value="RUB">RUB</Select.Item>
        //                         <Select.Item value="KZT">KZT</Select.Item>
        //                         <Select.Item value="USD">USD</Select.Item>
        //                         <Select.Item value="EUR">EUR</Select.Item>
        //                         <Select.Item value="UAH">UAH</Select.Item>
        //                     </Select.Content>
        //                 </Select.Root>
        //         </Box>
        //         <Flex justify={'end'}> 
        //         <Button variant='classic' loading={isLoading} onClick={async () => createTransaction()}>
        //             <ExternalLinkIcon />
        //             Оплатить
        //             </Button>
        //         </Flex>
        //     </Container>
        // </Container>
           <Flex align={'center'} justify={'center'} height={'90vh'} direction={'column-reverse'}>
              <Heading>Раздел в разработке</Heading>
              <ExclamationTriangleIcon width={'300px'} height={'300px'} />
        </Flex>
    )
}